// App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage.js';
import Login from './pages/Login.js';
import Register from './pages/Register.js';
import RegisterWithGoogle from './components/RegisterWithGoogle.js';
import PasswordReset from './pages/PasswordReset.js';
import Logout from './pages/Logout.js';
import Account from './pages/AccountPage.js';
import Ideas from './pages/Ideas.js';
import FaqPage from './pages/FaqPage.js';
import CompartiYGana from './pages/CompartiYGana.js';
import TerminosPage from './pages/TerminosPage.js';
import UneteAlEquipo from './pages/UniteAlEquipo.js';
import SearchPage from './pages/SearchPage.js';
import CajeroC from './pages/CajeroPage.js';
import Office from './pages/Office.js';
import EmpresaOffice from "./components/EmpresaOffice.js";
import PostulanteOffice from "./components/PostulanteOffice.js";
import OficinaProfesional from "./components/OficinaProfesional.js";
import UserOffice from './components/UserOffice.js';
import PrivateRoute from "./PrivateRoute.js";
import AdminPanel from "./pages/AdminPanel.js";
import PersonalCard from './pages/PersonalCard.js';
import Curriculum from "./pages/Curriculum.js";
import CompanyProfile from './pages/CompanyProfile.js';
import LandingPostulantesPage from './pages/LandingPostulantesPage.js';
import LandingPageProf from './pages/LandingPageProf.js';
import { AuthProvider, useAuth } from './context/AuthContext.js';
import { requestNotificationPermission } from "./services/notificationPermissions.js";
import { setupNotificationListener } from "./services/notificationListener.js";

import SuccessPage from './pages/SuccessPage.js';
import FailurePage from './pages/FailurePage.js';
import PendingPage from './pages/PendingPage.js';



function App() {
  const { currentUser, userRole } = useAuth();

  useEffect(() => {
    requestNotificationPermission();
  }, []);

  useEffect(() => {
    setupNotificationListener();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={!currentUser ? <Register /> : <Navigate to="/" />} />
          <Route path="/register-google" element={!currentUser ? <RegisterWithGoogle /> : <Navigate to="/" />} />
          <Route path="/login" element={!currentUser ? <Login /> : <Navigate to="/" />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/logout" element={currentUser ? <Logout /> : <Navigate to="/" />} />
          <Route path="/cuenta" element={<Account />} />
          <Route path="/idea" element={<Ideas />} />
          <Route path="/comparti-gana" element={<CompartiYGana />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/cajero" element={<CajeroC />} />
          <Route path="/buscar" element={<SearchPage />} />
          <Route path="/terminos-condiciones-de-uso-y-politicas-de-seguridad" element={<TerminosPage />} />
          <Route path="/se-parte" element={<UneteAlEquipo />} />
          <Route path="/oficina" element={ currentUser ? < Office /> : <Navigate to="/" />} />
          <Route path="/empresa-office" element={ currentUser ? < EmpresaOffice /> : <Navigate to="/" /> } />
          <Route path="/servicios-office" element={ currentUser ? < OficinaProfesional /> : <Navigate to="/" /> } />
          <Route path="/postulante-office" element={ currentUser ? < PostulanteOffice /> : <Navigate to="/" /> } />
          <Route path="/presupuestos-office" element={ currentUser ? < UserOffice /> : <Navigate to="/" /> } />
          <Route path="/personal-card/:uid" element={<PersonalCard />} />
          <Route path="/curriculum/:uid" element={<Curriculum />} /> 
          <Route path="/company-profile/:id" element={<CompanyProfile />} />
          {/* Rutas de mp pagos */}
          <Route path="/aprovado" element={<SuccessPage />} />
          <Route path="/fallo" element={<FailurePage />} />
          <Route path="/pending" element={<PendingPage />} />
          
          {/* Agrega más rutas según lo necesites */}
          <Route path="/admin/*" element={ <PrivateRoute requiredRole="admin"> <AdminPanel /> </PrivateRoute>}/>
          <Route path="/postulantes" element={<LandingPostulantesPage />} />
          <Route path="/profesionales" element={<LandingPageProf />} />

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
